import React from 'react';
import { useMediaQuery } from '@mui/material';
import BannerGoMidiaBH from '../../../../assets/images/banners/banner_site.png';
import BannerGoMidiaBHMobile from '../../../../assets/images/banners/banner-mobile.png';

const BannerHeader: React.FC = React.memo(() => {
  const matches = useMediaQuery('(max-width:1000px)', { noSsr: true });
  const bannerSrc = matches ? BannerGoMidiaBHMobile : BannerGoMidiaBH;
  return (
    <div className="banner-container">
      <a
        href="https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          width="100%"
          src={bannerSrc}
          alt={matches ? 'Banner GoMidiaBH Mobile' : 'Banner GoMidiaBH'}
          loading="lazy"
          decoding="async"
        />
      </a>
    </div>
  );
});

export { BannerHeader };